import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faTractor } from '@fortawesome/free-solid-svg-icons';
import { BasketContext } from './BasketContext';

function MobileNavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { basket } = useContext(BasketContext);

  const basketTotalItems = basket.reduce((total, item) => total + item.quantity, 0);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="mobile-nav">
      <div className="nav-header">
        <div className="hamburger" onClick={toggleMenu}>
          <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
        </div>
        <Link to="/tractor" className="mobile-cart" onClick={closeMenu}>
          <FontAwesomeIcon icon={faTractor} />
          {basketTotalItems > 0 && (<span>&nbsp;({basketTotalItems})</span>)}
        </Link>
      </div>
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <ul>
          <li className="mobile-nav-link"><Link to="/" onClick={closeMenu}>Home</Link></li>

          <hr className="menu-divider" />
          <li className="mobile-nav-group"><Link to="/products" onClick={closeMenu}>Product Info</Link></li>
          <li className="mobile-nav-group"><Link to="/compare" onClick={closeMenu}>Compare Products</Link></li>

          <hr className="menu-divider" />

          <li className="mobile-nav-group"><Link to="/grass" onClick={closeMenu}>Grass Finder</Link></li>
          <li className="mobile-nav-group"><Link to="/maize" onClick={closeMenu}>Maize Selector</Link></li>
          <li className="mobile-nav-group"><Link to="/mixer" onClick={closeMenu}>Seed Mixer</Link></li>

          <hr className="menu-divider" />

          {/*<li className="mobile-nav-group"><Link to="/team" onClick={closeMenu}>Meet the Team</Link></li>*/}
          <li className="mobile-nav-group"><Link to="/about-us" onClick={closeMenu}>About Us</Link></li>
          <li className="mobile-nav-group"><Link to="/agents" onClick={closeMenu}>Agent Finder</Link></li>
          <li className="mobile-nav-group"><Link to="/careers" onClick={closeMenu}>Careers</Link></li>
          <li className="mobile-nav-group"><Link to="/contact" onClick={closeMenu}>Contact Us</Link></li>

          <hr className="menu-divider" />

          <li className="mobile-nav-group"><Link to="/blogs" onClick={closeMenu}>Blogs</Link></li>
          <li className="mobile-nav-group"><Link to="/videos" onClick={closeMenu}>Videos</Link></li>

        </ul>
      </div>
    </nav>
  );
}

export default MobileNavBar;
